export interface Testimonial {
  initials: string
  name: string
  location: string
  quote: string
}

export interface Tomo {
  emoji: string
  title: string
  description: string
}

export interface Bono {
  number: string
  emoji: string
  title: string
  description: string
  price: string
}

export interface ComparisonRow {
  situation: string
  without: string
  with: string
}

export interface CostRow {
  factor: string
  cost: string
}

export const testimonials: Testimonial[] = [
  {
    initials: 'MD',
    name: 'Martín D.',
    location: 'Córdoba',
    quote:
      'Cobro un 30% más desde que implementé la estructura de precios. Los alumnos pagan felices porque ven profesionalismo.',
  },
  {
    initials: 'SL',
    name: 'Sandra L.',
    location: 'Buenos Aires',
    quote:
      'Los médicos comenzaron a derivarme. La Carta para el Médico funcionó. Ya tengo 5 kinesiólogos que me derivan regularmente.',
  },
  {
    initials: 'CP',
    name: 'Claudia P.',
    location: 'Rosario',
    quote:
      'Las Banderas Rojas me salvaron. Detecté síndrome de cauda equina y derivé urgente. Sin esto no lo habría reconocido.',
  },
  {
    initials: 'RG',
    name: 'Roxana G.',
    location: 'Mendoza',
    quote:
      'El Tomo de Embarazo es único. Trimestre a trimestre. Cobro 50% más a embarazadas. Tienen ficha, consentimiento, todo documentado.',
  },
]

export const painPoints: string[] = [
  'No sabés exactamente qué ejercicios adaptar',
  'No reconocés síntomas graves (banderas rojas)',
  'No tenés protección legal: sin fichas ni consentimientos',
  'No coordinás con médicos: perdés referenciaciones',
  'No cobrás diferente por complejidad: trabajás más, ganás igual',
  'Tenés miedo cada vez que algo sale “diferente”',
]

export const tomos: Tomo[] = [
  {
    emoji: '📘',
    title: 'Tomo 1 — Columna y Movimiento',
    description:
      'Adaptaciones para hernias, cifosis, escoliosis y limitaciones de movilidad de columna.',
  },
  {
    emoji: '📗',
    title: 'Tomo 2 — Miembros Inferiores',
    description:
      'Ejercicios modificados para limitaciones de rodilla, cadera, tobillo e impacto.',
  },
  {
    emoji: '📙',
    title: 'Tomo 3 — Miembros Superiores',
    description:
      'Adaptaciones de hombro, codo, muñeca y problemas de manguito rotador.',
  },
  {
    emoji: '📕',
    title: 'Tomo 4 — Pilates Senior',
    description:
      'Protocolos seguros para adultos mayores, osteoporosis y prevención de caídas.',
  },
  {
    emoji: '📓',
    title: 'Tomo 5 — Embarazo y Postparto',
    description:
      'Adaptaciones por trimestre, diástasis de rectos y recuperación postparto completa.',
  },
  {
    emoji: '📔',
    title: 'Tomo 6 — Observación del Movimiento',
    description:
      'Cómo evaluar, reconocer limitaciones y seleccionar adaptaciones correctas.',
  },
]

export const tomoIncludes: string[] = [
  '30 sesiones planificadas por tomo',
  'Tres versiones por ejercicio: principiante, intermedio y avanzado',
  'Instrucciones de voz listas para decir en clase',
]

export const bonos: Bono[] = [
  {
    number: '01',
    emoji: '⚠️',
    title: 'Banderas Rojas y Señales de Alerta',
    description:
      '33 síntomas que requieren detener la clase y derivar a médico inmediatamente. Protección legal + salud del alumno.',
    price: '$10.000',
  },
  {
    number: '02',
    emoji: '📖',
    title: 'Diccionario Médico–Profe',
    description:
      'Hernias, estenosis, preeclampsia, esclerosis. Entendés lo que dice el médico del alumno. Credibilidad total.',
    price: '$9.000',
  },
  {
    number: '03',
    emoji: '⏱️',
    title: 'Secuencias Express de Movilidad Suave',
    description:
      '8 rutinas de 10 a 15 minutos para cuando el alumno llega con dolor o muy limitado. Salva tu clase.',
    price: '$8.000',
  },
  {
    number: '04',
    emoji: '📞',
    title: 'Kit de Comunicación con Kinesiólogos',
    description:
      'Plantillas profesionales para contactar médicos, kinesiólogos y construir red de derivaciones.',
    price: '$11.000',
  },
  {
    number: '05',
    emoji: '🪑',
    title: 'Kit de Elementos para Adaptaciones',
    description:
      '30 adaptaciones con toalla, bloque, pelota, silla, banda y rodillo. Nunca te falta nada.',
    price: '$10.000',
  },
  {
    number: '06',
    emoji: '🏥',
    title: 'Atlas Visual de Adaptaciones',
    description:
      'Ejercicio original + 4 alternativas visuales. Listo para mostrarle al alumno. Confianza inmediata.',
    price: '$12.000',
  },
]

export const premiumRows: ComparisonRow[] = [
  {
    situation: 'Alumno con hernia llega',
    without: 'Adaptás ejercicios',
    with: '+ Cobrás 30% más + Documentás + Coordinás con médico',
  },
  {
    situation: '¿Qué precio cobrar?',
    without: 'Improvisás',
    with: '5 modelos de pricing probados en Argentina',
  },
  {
    situation: 'Un incidente sucede',
    without: 'Sin documentación',
    with: 'Ficha + Consentimiento + Registro. Protegido legalmente.',
  },
  {
    situation: 'Networking con médicos',
    without: 'No sabés presentarte',
    with: 'Protocolo profesional + plantillas listas',
  },
  {
    situation: 'Ingresos anuales',
    without: 'Mismos precios, más trabajo',
    with: '+$57.600 USD/año mínimo con alumnos adaptados',
  },
]

export const premiumIncludes: { title: string; description: string }[] = [
  {
    title: 'Protocolo de Admisión',
    description:
      'Las 10 preguntas clínicas + evaluación funcional + clearance médico.',
  },
  {
    title: 'Protección Legal',
    description:
      'Ficha de evaluación, consentimiento informado, autorización de comunicación y registro de incidentes.',
  },
  {
    title: 'Estructura de Precios',
    description:
      '5 modelos probados: clase grupal adaptativa, individual, paquetes y diferencial por patología.',
  },
  {
    title: 'Marketing Ético',
    description:
      '5 mensajes que venden + guión de venta + cómo hablarle a alguien asustado.',
  },
  {
    title: 'Comunicación Profesional',
    description:
      'Carta para el médico, protocolo de seguimiento y cómo construir tu red de derivaciones.',
  },
  {
    title: 'Plan de 30 Días',
    description:
      'Auditoría, protocolos, precios y networking. Paso a paso para escalar.',
  },
]

export const costRows: CostRow[] = [
  {
    factor:
      '1 alumno adaptado por mes que NO atendés porque no sabés cobrar',
    cost: '$200 USD/mes × 12 = $2.400/año',
  },
  {
    factor: '5 alumnos × diferencial no cobrado × 4 clases/mes × 12 meses',
    cost: '+$2.400/año',
  },
  {
    factor: '3 derivaciones médicas que no recibís sin red profesional',
    cost: '10 alumnos × $180 USD = +$21.600/año',
  },
  {
    factor: '1 incidente sin documentación que genera juicio',
    cost: '−$10.000 a −$100.000',
  },
  {
    factor: 'Horas de ansiedad sin protocolo claro',
    cost: 'Invaluable',
  },
]

export const costTotal: CostRow = {
  factor: 'Total perdido en un año',
  cost: '+$25.200 USD mínimo',
}

export const faqs: { question: string; answer: string }[] = [
  {
    question: '¿Sirve si tengo pocos alumnos limitados?',
    answer:
      'Especialmente. Este sistema te ayuda a ATRAER alumnos adaptados y cobrarles profesionalmente. Si tenés 5 alumnos adaptados y pasás a 12, ¿cuánto ganás?',
  },
  {
    question: '¿Cómo recibo el material?',
    answer:
      'Email con links de descarga en PDF. Acceso inmediato en 5 minutos. Guardás todo en Google Drive para siempre.',
  },
  {
    question: '¿Funciona para clases online y a domicilio?',
    answer:
      'Perfecto. Es incluso más valioso, porque la documentación legal es tu máxima protección cuando no tenés estructura física.',
  },
  {
    question: '¿Necesito otra capacitación?',
    answer:
      'No. Asumimos que sos instructor de Pilates certificado. Esto es el “cómo adaptar seguro, con protección legal y escalamiento”.',
  },
  {
    question: '¿Cuál es la diferencia entre Clinic y Premium?',
    answer:
      'Clinic: adaptaciones por diagnóstico (6 tomos) + bonos de protección y comunicación. Premium: todo lo anterior + cómo cobrar más + red profesional de médicos + sistema completo de escalamiento.',
  },
]

export const transformation = {
  before:
    '“Lo siento, necesitás supervisión médica. Vení cuando estés mejor.”',
  after:
    '“Perfecto, tenemos protocolo seguro para esto. Triángulo de Seguridad, evaluación y coordinación médica. Esto sale $150 por clase, en lugar de $100.”',
  cycle: [
    'El alumno mejora su movilidad funcional',
    'Vos cobrás 30% más',
    'El médico confía en vos y te deriva más',
    'La red profesional se arma sola',
  ],
}
